/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';

@tagName('')
export default class LastTested extends Component {
  // external API
  recipient = null;

  platform = null;
  type = null;
  lastTestedRecipient = null;
  disabled = false;
  sendToSandbox = false;

  onLastTestedRecipientChecked() {
    throw new Error('onShowWebhookModal must be provided');
  }

  // internal API
  @computed('lastTestedRecipient', 'recipient', 'platform', 'type', 'sendToSandbox')
  get lastTestedRecipientChecked() {
    let { lastTestedRecipient, recipient, platform, type, sendToSandbox } = this.getProperties(
      'lastTestedRecipient',
      'recipient',
      'platform',
      'type',
      'sendToSandbox',
    );

    if (type === 'push' && !isEmpty(lastTestedRecipient)) {
      return (
        lastTestedRecipient.id === recipient &&
        lastTestedRecipient.platform === platform &&
        (isEmpty(lastTestedRecipient.sandbox) || lastTestedRecipient.sandbox === sendToSandbox)
      );
    }

    return lastTestedRecipient === recipient;
  }
}
